/* Little Liya Co. — main.js */

/* ===== SCROLL FADE-IN ===== */
(function () {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.fade-up').forEach(function (el) { io.observe(el); });
})();

/* ===== PARALLAX HERO ===== */
(function () {
  var heroImg = document.querySelector('.hero-right img');
  if (!heroImg) return;
  window.addEventListener('scroll', function () {
    var scrollY = window.scrollY;
    heroImg.style.transform = 'translateY(' + (scrollY * 0.18).toFixed(1) + 'px)';
  }, { passive: true });
})();

/* ===== MOBILE MENU ===== */
function toggleMobileMenu() {
  var nav = document.getElementById('mobile-nav');
  if (nav) nav.classList.toggle('open');
}

/* ===== GALLERY THUMB CLICK ===== */
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('.thumb');
  if (!thumb) return;
  var img = thumb.querySelector('img');
  if (!img) return;
  var mainImg = document.getElementById('main-product-img');
  if (mainImg) mainImg.src = img.src.replace(/width=\d+/, 'width=900');
  document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
  thumb.classList.add('active');
});

/* ===== CART DRAWER ===== */
function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}

function openCartDrawer() {
  fetchAndRenderCart();
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

function fetchAndRenderCart() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
    });
}

function renderCartDrawer(cart) {
  var empty   = document.getElementById('cart-drawer-empty');
  var footer  = document.getElementById('cart-drawer-footer');
  var itemsEl = document.getElementById('cart-drawer-items');
  var total   = document.getElementById('drawer-total');
  var count   = document.getElementById('drawer-count');

  if (count) count.textContent = cart.item_count;
  if (total) total.textContent = formatMoney(cart.total_price);

  // Remove all existing item rows (keep empty state div)
  Array.from(itemsEl.children).forEach(function (child) {
    if (child.id !== 'cart-drawer-empty') itemsEl.removeChild(child);
  });

  if (cart.item_count === 0) {
    empty.style.display  = 'flex';
    footer.style.display = 'none';
    return;
  }

  empty.style.display  = 'none';
  footer.style.display = 'block';

  cart.items.forEach(function (item) {
    var props = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (item.properties[k]) {
          props += '<div class="cart-item-prop">' + k + ': ' + item.properties[k] + '</div>';
        }
      });
    }
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-item-variant">' + item.variant_title + '</div>' : '';
    var imgSrc  = item.image ? item.image.replace(/(\.\w+)$/, '_72x72_crop_center$1') : '';
    var imgTag  = imgSrc
      ? '<img class="cart-item-img" src="' + imgSrc + '" alt="' + item.product_title + '">'
      : '<div class="cart-item-img"></div>';

    var row = document.createElement('div');
    row.className = 'cart-drawer-item';
    row.dataset.key = item.key;
    row.innerHTML = imgTag +
      '<div class="cart-item-info">' +
        '<div class="cart-item-name">' + item.product_title + '</div>' +
        variant + props +
        '<div class="cart-item-controls">' +
          '<div class="cart-item-qty">' +
            '<button onclick="changeDrawerQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">&#8722;</button>' +
            '<span class="cart-item-qty-num">' + item.quantity + '</span>' +
            '<button onclick="changeDrawerQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">&#43;</button>' +
          '</div>' +
          '<span class="cart-item-price">' + formatMoney(item.line_price) + '</span>' +
        '</div>' +
        '<button class="cart-item-remove" onclick="changeDrawerQty(\'' + item.key + '\',0)">Remove</button>' +
      '</div>';
    itemsEl.appendChild(row);
  });
}

function changeDrawerQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
    });
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(function (el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
  var dc = document.getElementById('drawer-count');
  if (dc) dc.textContent = count;
}

// Intercept Add to Cart form submits
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (form.id !== 'product-form' && !form.classList.contains('product-form-ajax')) return;
  e.preventDefault();

  var btn = form.querySelector('[name="add"]');
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

  var body = new FormData(form);
  fetch('/cart/add.js', { method: 'POST', body: body })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (btn) { btn.textContent = 'Added!'; }
      fetchAndRenderCart();
      openCartDrawer();
      setTimeout(function () {
        if (btn) { btn.textContent = 'Add to Basket'; btn.disabled = false; }
      }, 2000);
    })
    .catch(function () {
      if (btn) { btn.textContent = 'Add to Basket'; btn.disabled = false; }
    });
});

// Header cart icon click
document.addEventListener('click', function (e) {
  var cartIcon = e.target.closest('.cart-icon, .header-cart');
  if (cartIcon) {
    e.preventDefault();
    openCartDrawer();
  }
});

// Load cart count on page load
fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); });

/* ===== QUICK ADD (on collection / product cards) ===== */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.quick-add-btn');
  if (!btn) return;
  e.preventDefault();
  var variantId = btn.dataset.variantId;
  if (!variantId) return;
  btn.textContent = 'Adding...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Added!';
      fetchAndRenderCart();
      openCartDrawer();
      setTimeout(function () { btn.textContent = 'Add to Basket'; }, 2000);
    });
});

/* ===== QUICK VIEW ===== */
function openQuickView(handle) {
  var overlay = document.getElementById('qv-overlay');
  var modal   = document.getElementById('qv-modal');
  var content = document.getElementById('qv-content');
  content.innerHTML = '<p style="text-align:center;padding:40px;color:var(--taupe);">Loading…</p>';
  overlay.classList.add('open');
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';

  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) {
      var price     = formatMoney(p.price);
      var img       = p.featured_image || '';
      var variantId = p.variants[0].id;
      var personalised = p.tags && p.tags.some(function (t) { return t.toLowerCase().indexOf('personalised') !== -1; });
      var persInput = personalised
        ? '<input type="text" name="properties[Name]" placeholder="Enter name to personalise" maxlength="20" class="qv-personalisation">'
        : '';
      content.innerHTML =
        '<img class="qv-img" src="' + img + '" alt="' + p.title + '">' +
        '<div class="qv-info">' +
          '<h2>' + p.title + '</h2>' +
          '<div class="qv-price">' + price + '</div>' +
          '<p style="font-size:13px;color:var(--taupe);margin-bottom:18px;">' +
            (p.description || '').replace(/<[^>]+>/g, '').substring(0, 200) +
            (p.description && p.description.length > 200 ? '…' : '') +
          '</p>' +
          persInput +
          '<button class="btn-primary" style="width:100%;padding:14px;" onclick="qvAddToCart(this,' + variantId + ')">Add to Basket</button>' +
          '<a href="/products/' + p.handle + '" style="display:block;text-align:center;margin-top:12px;font-size:13px;color:var(--taupe);">View full details</a>' +
        '</div>';
    });
}

function qvAddToCart(btn, variantId) {
  var persInput = document.querySelector('#qv-content .qv-personalisation');
  var props     = {};
  if (persInput && persInput.value) props['Name'] = persInput.value;
  btn.textContent = 'Adding...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1, properties: props })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Added!';
      fetchAndRenderCart();
      setTimeout(function () {
        closeQuickView();
        openCartDrawer();
      }, 700);
    });
}

function closeQuickView() {
  document.getElementById('qv-overlay').classList.remove('open');
  document.getElementById('qv-modal').classList.remove('open');
  document.body.style.overflow = '';
}


/* ===== PROMO POPUP ===== */
(function () {
  if (localStorage.getItem('llc_popup_hello40')) return;
  setTimeout(function () {
    document.getElementById('promo-overlay').classList.add('open');
    document.getElementById('promo-popup').classList.add('open');
  }, 4000);
})();

function closePromoPopup() {
  document.getElementById('promo-overlay').classList.remove('open');
  document.getElementById('promo-popup').classList.remove('open');
  localStorage.setItem('llc_popup_hello40', '1');
}

/* ===== BACK TO TOP ===== */
(function () {
  var btn = document.getElementById('back-to-top');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    if (window.scrollY > 400) {
      btn.classList.add('visible');
    } else {
      btn.classList.remove('visible');
    }
  }, { passive: true });
})();

/* ===== IMAGE ZOOM (product page) ===== */
(function () {
  var wrap = document.querySelector('.zoom-wrap');
  if (!wrap) return;
  wrap.addEventListener('click', function (e) {
    wrap.classList.toggle('zoomed');
    setZoomOrigin(e, wrap);
  });
  wrap.addEventListener('mousemove', function (e) {
    if (!wrap.classList.contains('zoomed')) return;
    setZoomOrigin(e, wrap);
  });
  function setZoomOrigin(e, el) {
    var rect = el.getBoundingClientRect();
    var ox = ((e.clientX - rect.left) / rect.width * 100).toFixed(1) + '%';
    var oy = ((e.clientY - rect.top) / rect.height * 100).toFixed(1) + '%';
    el.style.setProperty('--ox', ox);
    el.style.setProperty('--oy', oy);
  }
})();

/* ===== DISPATCH COUNTDOWN ===== */
(function () {
  var el = document.getElementById('countdown-time');
  if (!el) return;
  function tick() {
    var now    = new Date();
    var cutoff = new Date();
    cutoff.setHours(14, 0, 0, 0); // 2pm cutoff
    var diff   = cutoff - now;
    if (diff <= 0) {
      cutoff.setDate(cutoff.getDate() + 1);
      diff = cutoff - now;
    }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    el.textContent = (h > 0 ? h + 'h ' : '') + m + 'm ' + s + 's';
  }
  tick();
  setInterval(tick, 1000);
})();
